import { PageController } from '@client/components/_core/layout/PageController';
import { History } from '@client/components/_ui/display/History';
import { createFileRoute } from '@tanstack/react-router';
import { incidentFormStore } from '../store';

export const Route = createFileRoute('/console/$orgId/compliance/incidents/details/$id/history')({
    component: IncidentHistoryTab,
});

function IncidentHistoryTab() {
    const incident = incidentFormStore.use.formData();

    return (
        <PageController route={Route}>
            <History idValue={incident.id} idPropertyName="incidentId" />
        </PageController>
    );
}
